// extracted by mini-css-extract-plugin
export default {"wrapper":"PotBoosterNotification-module__wrapper","overlayButton":"PotBoosterNotification-module__overlayButton"};